module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-coast-851a270584d585b8e4cc9cb24dc820a7.svg";